import React, { useState, useContext, useRef, useEffect, useMemo } from "react";
import Swal from "sweetalert2";

import AuthService from "../../../../services/Admin/AuthService";
import CompanyService from "../../../../services/Admin/CompanyService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

/* ------------------------------------------------------------------ */
/*  Emoji data (kept small so no external dependency is needed)        */
/* ------------------------------------------------------------------ */
const EMOJI_GROUPS = [
  {
    label: "Smileys",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "😂",
      "🤣",
      "😊",
      "😇",
      "🙂",
      "🙃",
      "😉",
      "😌",
      "😍",
      "🥰",
      "😘",
      "😗",
      "😙",
      "😚",
      "😋",
      "😛",
      "😝",
      "😜",
      "🤪",
      "🤨",
      "🧐",
      "🤓",
      "😎",
      "🥳",
      "😏",
      "😒",
      "😞",
      "😔",
      "😟",
      "😕",
      "🙁",
      "☹️",
      "😣",
      "😖",
      "😫",
      "😩",
      "🥺",
      "😢",
      "😭",
      "😤",
      "😠",
      "😡",
      "🤬",
      "🤯",
      "😳",
      "🥵",
      "🥶",
      "😱",
      "😨",
      "😰",
      "😥",
      "😓",
      "🤗",
      "🤔",
      "🤭",
      "🤫",
      "🤥",
      "😶",
      "😐",
      "😑",
      "😬",
      "🙄",
      "😯",
      "😦",
      "😮",
      "😲",
      "🥱",
      "😴",
      "🤤",
      "😪",
      "😵",
      "🤐",
      "🥴",
      "🤢",
      "🤮",
      "🤧",
      "😷",
      "🤒",
      "🤕",
      "🤑",
      "🤠",
      "😈",
      "👿",
      "👹",
      "👺",
      "🤡",
      "💩",
      "👻",
      "💀",
      "👽",
      "👾",
      "🤖",
      "🎃",
      "😺",
      "😸",
      "😹",
      "😻",
      "😼",
      "😽",
      "🙀",
      "😿",
      "😾",
    ],
  },
  {
    label: "Gestures",
    emojis: [
      "👋",
      "🤚",
      "🖐",
      "✋",
      "🖖",
      "👌",
      "🤏",
      "✌️",
      "🤞",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "👇",
      "☝️",
      "👍",
      "👎",
      "✊",
      "👊",
      "🤛",
      "🤜",
      "👏",
      "🙌",
      "👐",
      "🤲",
      "🤝",
      "🙏",
      "✍️",
      "💅",
      "🤳",
      "💪",
      "🦾",
      "🦵",
      "🦶",
      "👂",
      "🦻",
      "👃",
      "🧠",
      "🦷",
      "🦴",
      "👀",
      "👁",
      "👅",
      "👄",
      "💋",
    ],
  },
  {
    label: "Hearts",
    emojis: [
      "❤️",
      "🧡",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "🤍",
      "🤎",
      "💔",
      "❣️",
      "💕",
      "💞",
      "💓",
      "💗",
      "💖",
      "💘",
      "💝",
      "💟",
      "♥️",
      "💌",
      "💋",
      "🔥",
      "⭐",
      "🌟",
      "✨",
      "⚡",
      "💥",
      "💫",
      "🌈",
      "☀️",
      "⛅",
      "☁️",
      "🌧",
      "⛈",
      "🌩",
      "❄️",
      "☃️",
      "⛄",
      "🌊",
      "💧",
      "🎉",
      "🎊",
      "🎈",
      "🎁",
      "🏆",
      "🥇",
      "🎯",
      "💯",
      "✅",
      "❌",
      "❗",
      "❓",
      "⚠️",
    ],
  },
  {
    label: "Objects",
    emojis: [
      "📱",
      "💻",
      "⌨️",
      "🖥",
      "🖨",
      "🖱",
      "💾",
      "💿",
      "📀",
      "📷",
      "📸",
      "📹",
      "🎥",
      "📞",
      "☎️",
      "📟",
      "📠",
      "📺",
      "📻",
      "🎙",
      "🎚",
      "🎛",
      "⏱",
      "⏲",
      "⏰",
      "🕰",
      "⌛",
      "⏳",
      "📡",
      "🔋",
      "🔌",
      "💡",
      "🔦",
      "🕯",
      "🛢",
      "💸",
      "💵",
      "💴",
      "💶",
      "💷",
      "💰",
      "💳",
      "💎",
      "⚖️",
      "🧰",
      "🔧",
      "🔨",
      "⚒",
      "🛠",
      "⛏",
      "🔩",
      "⚙️",
      "🧱",
      "⛓",
      "🧲",
      "🔫",
      "💣",
      "🧨",
      "🪓",
      "🔪",
      "🗡",
      "⚔️",
      "🛡",
      "🚬",
      "⚰️",
      "🏺",
      "🔮",
      "📿",
      "🧿",
      "💈",
      "⚗️",
      "🔭",
      "🔬",
      "🕳",
      "💊",
      "💉",
      "🩸",
      "🩹",
      "🩺",
      "🌡",
      "🧬",
      "🦠",
      "🧫",
      "🧪",
      "🌿",
    ],
  },
  {
    label: "Food",
    emojis: [
      "🍏",
      "🍎",
      "🍐",
      "🍊",
      "🍋",
      "🍌",
      "🍉",
      "🍇",
      "🍓",
      "🍈",
      "🍒",
      "🍑",
      "🥭",
      "🍍",
      "🥥",
      "🥝",
      "🍅",
      "🍆",
      "🥑",
      "🥦",
      "🥬",
      "🥒",
      "🌶",
      "🌽",
      "🥕",
      "🧄",
      "🧅",
      "🥔",
      "🍠",
      "🥐",
      "🥯",
      "🍞",
      "🥖",
      "🥨",
      "🧀",
      "🥚",
      "🍳",
      "🧈",
      "🥞",
      "🧇",
      "🥓",
      "🥩",
      "🍗",
      "🍖",
      "🦴",
      "🌭",
      "🍔",
      "🍟",
      "🍕",
      "🥪",
      "🥙",
      "🧆",
      "🌮",
      "🌯",
      "🥗",
      "🥘",
      "🥫",
      "🍝",
      "🍜",
      "🍲",
      "🍛",
      "🍣",
      "🍱",
      "🥟",
      "🦪",
      "🍤",
      "🍙",
      "🍚",
      "🍘",
      "🍥",
      "🥠",
      "🥮",
      "🍢",
      "🍡",
      "🍧",
      "🍨",
      "🍦",
      "🥧",
      "🧁",
      "🍰",
      "🎂",
      "🍮",
      "🍭",
      "🍬",
      "🍫",
      "🍿",
      "🍩",
      "🍪",
      "🌰",
      "🥜",
      "🍯",
      "🥛",
      "🍼",
      "☕",
      "🍵",
      "🧃",
      "🥤",
      "🍶",
      "🍺",
      "🍻",
      "🥂",
      "🍷",
      "🥃",
      "🍸",
      "🍹",
      "🧉",
      "🍾",
    ],
  },
];

/* ------------------------------------------------------------------ */
/*  Small reusable toolbar button                                      */
/* ------------------------------------------------------------------ */
const ToolbarButton = ({
  icon,
  label,
  active,
  disabled,
  onMouseDown,
  onClick,
}) => (
  <button
    type="button"
    className={`fm-tool${active ? " fm-tool--active" : ""}`}
    title={label}
    aria-label={label}
    aria-pressed={!!active}
    disabled={disabled}
    onMouseDown={onMouseDown}
    onClick={onClick}
  >
    <i className={icon} />
  </button>
);

/* ------------------------------------------------------------------ */
/*  Main component                                                     */
/* ------------------------------------------------------------------ */
const FlashMessage = ({ data, onSaved }) => {
  const loadingCtx = useContext(LoadingContext);

  const editorRef = useRef(null);
  const emojiBtnRef = useRef(null);
  const emojiPanelRef = useRef(null);

  const [html, setHtml] = useState(() => (data && data.flash_message) || "");
  const [emojiOpen, setEmojiOpen] = useState(false);
  const [emojiGroup, setEmojiGroup] = useState(0);
  const [activeFormats, setActiveFormats] = useState({});
  const [saving, setSaving] = useState(false);

  /* plain-text version for the counter */
  const charCount = useMemo(
    () => html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").length,
    [html],
  );

  /* ---------- one-time editor init ---------- */
  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.innerHTML = (data && data.flash_message) || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------- track which formats are active at the caret ---------- */
  useEffect(() => {
    const onSelectionChange = () => {
      if (!editorRef.current) return;
      try {
        setActiveFormats({
          bold: document.queryCommandState("bold"),
          italic: document.queryCommandState("italic"),
          underline: document.queryCommandState("underline"),
          strikeThrough: document.queryCommandState("strikeThrough"),
        });
      } catch (_) {
        /* some browsers throw when there is no selection */
      }
    };
    document.addEventListener("selectionchange", onSelectionChange);
    return () =>
      document.removeEventListener("selectionchange", onSelectionChange);
  }, []);

  /* ---------- close emoji popover on outside click ---------- */
  useEffect(() => {
    if (!emojiOpen) return;
    const onDown = (event) => {
      const panel = emojiPanelRef.current;
      const btn = emojiBtnRef.current;
      if (
        panel &&
        !panel.contains(event.target) &&
        btn &&
        !btn.contains(event.target)
      ) {
        setEmojiOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [emojiOpen]);

  /* ---------- helpers ---------- */
  const syncHtml = () => {
    if (editorRef.current) setHtml(editorRef.current.innerHTML);
  };

  const exec = (command, value = null) => {
    if (editorRef.current) editorRef.current.focus();
    document.execCommand(command, false, value);
    syncHtml();
  };

  const insertEmoji = (emoji) => {
    if (editorRef.current) editorRef.current.focus();
    document.execCommand("insertText", false, emoji);
    syncHtml();
    setEmojiOpen(false);
  };

  const addLink = () => {
    const url = window.prompt("Enter URL (https://...)", "https://");
    if (url && url.trim() !== "https://") exec("createLink", url.trim());
  };

  const handlePaste = (event) => {
    // paste as plain text so we don't inject foreign styles/markup
    event.preventDefault();
    const text = (event.clipboardData || window.clipboardData).getData(
      "text/plain",
    );
    document.execCommand("insertText", false, text);
    syncHtml();
  };

  /* ---------- save ---------- */
  const saveHandler = async () => {
    const message = editorRef.current ? editorRef.current.innerHTML.trim() : "";

    loadingCtx.startLoading();
    setSaving(true);

    try {
      const token = AuthService.getAccessToken();
      const responseData = await CompanyService.updateFlashMessage(
        token,
        message,
      );

      const status = responseData.status;
      const responseMessage = responseData.message;

      if (status === "SUCCESS") {
        Swal.fire("Success!", responseMessage, "success");
        if (onSaved) onSaved(responseData);
      } else {
        Swal.fire("Opps!", responseMessage, "error");
      }
    } catch (error) {
      Swal.fire("Opps!", HttpError.getError(error), "error");
    } finally {
      loadingCtx.stopLoading();
      setSaving(false);
    }
  };

  /* ---------- render ---------- */
  return (
    <React.Fragment>
      <style>{styles}</style>

      <div className="row">
        <div className="col-md-8 mx-auto">
          <div className="card fm-card">
            <div className="card-header fm-card__header">
              <div>
                <h3 className="card-title mb-0">
                  <i className="fas fa-bullhorn mr-2" />
                  Flash Message
                </h3>
              </div>
            </div>

            <div className="card-body">
              {/* -------------------- editor -------------------- */}
              <div className="fm-editor">
                <div
                  className="fm-toolbar"
                  role="toolbar"
                  aria-label="Text formatting"
                >
                  <ToolbarButton
                    icon="fas fa-bold"
                    label="Bold (Ctrl+B)"
                    active={activeFormats.bold}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => exec("bold")}
                  />
                  <ToolbarButton
                    icon="fas fa-italic"
                    label="Italic (Ctrl+I)"
                    active={activeFormats.italic}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => exec("italic")}
                  />
                  <ToolbarButton
                    icon="fas fa-underline"
                    label="Underline (Ctrl+U)"
                    active={activeFormats.underline}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => exec("underline")}
                  />
                  <ToolbarButton
                    icon="fas fa-strikethrough"
                    label="Strikethrough"
                    active={activeFormats.strikeThrough}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => exec("strikeThrough")}
                  />

                  <span className="fm-toolbar__divider" />

                  <ToolbarButton
                    icon="fas fa-link"
                    label="Insert link"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={addLink}
                  />
                  <ToolbarButton
                    icon="fas fa-eraser"
                    label="Clear formatting"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => exec("removeFormat")}
                  />

                  <span className="fm-toolbar__divider" />

                  {/* emoji trigger */}
                  <div className="fm-emoji-wrap">
                    <button
                      ref={emojiBtnRef}
                      type="button"
                      className={`fm-tool${emojiOpen ? " fm-tool--active" : ""}`}
                      title="Insert emoji"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => setEmojiOpen((v) => !v)}
                    >
                      <i className="far fa-smile" />
                    </button>

                    {emojiOpen && (
                      <div className="fm-emoji" ref={emojiPanelRef}>
                        <div className="fm-emoji__tabs">
                          {EMOJI_GROUPS.map((group, i) => (
                            <button
                              key={group.label}
                              type="button"
                              className={
                                "fm-emoji__tab" +
                                (i === emojiGroup ? " is-active" : "")
                              }
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => setEmojiGroup(i)}
                            >
                              {group.label}
                            </button>
                          ))}
                        </div>
                        <div className="fm-emoji__grid">
                          {EMOJI_GROUPS[emojiGroup].emojis.map((emoji, i) => (
                            <button
                              key={`${emoji}-${i}`}
                              type="button"
                              className="fm-emoji__item"
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => insertEmoji(emoji)}
                            >
                              {emoji}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  ref={editorRef}
                  className="fm-content"
                  contentEditable
                  suppressContentEditableWarning
                  role="textbox"
                  aria-multiline="true"
                  data-placeholder="Type your flash message… e.g. 🎉 Double data on every top-up this weekend!"
                  onInput={syncHtml}
                  onBlur={syncHtml}
                  onPaste={handlePaste}
                />
              </div>

              {/* -------------------- live preview -------------------- */}
              <div className="fm-preview">
                <div className="fm-preview__label">
                  <i className="fas fa-eye mr-1" /> Live preview
                </div>
                <div className="fm-preview__banner">
                  {html ? (
                    <div dangerouslySetInnerHTML={{ __html: html }} />
                  ) : (
                    <span className="fm-preview__empty">
                      Your message will appear here…
                    </span>
                  )}
                </div>
              </div>

              {/* -------------------- footer -------------------- */}
              <div className="fm-footer">
                <span
                  className={
                    "fm-counter" + (charCount > 240 ? " fm-counter--warn" : "")
                  }
                >
                  {charCount} character{charCount === 1 ? "" : "s"}
                </span>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={saveHandler}
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <i className="fas fa-spinner fa-spin mr-1" /> Saving…
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save mr-1" /> Save Changes
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

/* ------------------------------------------------------------------ */
/*  Styles – move to your own .css file if you prefer                  */
/* ------------------------------------------------------------------ */
const styles = `
.fm-card{border:1px solid #e6e9ef;border-radius:.6rem;box-shadow:0 2px 10px rgba(15,23,42,.05);}
.fm-card__header{background:#fff;border-bottom:1px solid #eef1f5;padding:14px 18px;}

.fm-editor{border:1px solid #d8dee7;border-radius:.5rem;overflow:hidden;background:#fff;transition:border-color .15s ease,box-shadow .15s ease;}
.fm-editor:focus-within{border-color:#17a2b8;box-shadow:0 0 0 3px rgba(23,162,184,.15);}

.fm-toolbar{display:flex;align-items:center;gap:4px;flex-wrap:wrap;padding:6px 8px;background:#f7f9fc;border-bottom:1px solid #eef1f5;}
.fm-toolbar__divider{width:1px;height:20px;background:#e1e6ee;margin:0 4px;}

.fm-tool{display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border:1px solid transparent;border-radius:.35rem;background:transparent;color:#5b6572;cursor:pointer;font-size:.85rem;transition:background .12s ease,color .12s ease,border-color .12s ease;}
.fm-tool:hover{background:#eaf3f6;color:#17a2b8;}
.fm-tool:active{transform:scale(.96);}
.fm-tool:disabled{opacity:.45;cursor:not-allowed;}
.fm-tool--active{background:#e6f6fa;color:#0f8ea5;border-color:#bfe7f1;}

.fm-content{min-height:120px;max-height:280px;overflow-y:auto;padding:14px 16px;font-size:.95rem;line-height:1.55;color:#1f2d3d;outline:none;}
.fm-content:empty::before{content:attr(data-placeholder);color:#a5adba;pointer-events:none;}
.fm-content a{color:#17a2b8;text-decoration:underline;}
.fm-content b,.fm-content strong{font-weight:700;}

/* emoji popover */
.fm-emoji-wrap{position:relative;}
.fm-emoji{position:absolute;top:38px;left:0;z-index:30;width:320px;background:#fff;border:1px solid #e1e6ee;border-radius:.55rem;box-shadow:0 10px 28px rgba(15,23,42,.14);overflow:hidden;}
.fm-emoji__tabs{display:flex;background:#f7f9fc;border-bottom:1px solid #eef1f5;overflow-x:auto;}
.fm-emoji__tab{flex:1 0 auto;padding:7px 10px;border:0;background:transparent;font-size:.72rem;font-weight:600;color:#7b8591;cursor:pointer;white-space:nowrap;}
.fm-emoji__tab:hover{color:#17a2b8;}
.fm-emoji__tab.is-active{color:#0f8ea5;box-shadow:inset 0 -2px 0 #17a2b8;}
.fm-emoji__grid{display:grid;grid-template-columns:repeat(8,1fr);gap:2px;max-height:200px;overflow-y:auto;padding:6px;}
.fm-emoji__item{border:0;background:transparent;font-size:1.15rem;line-height:1;padding:5px 0;border-radius:.3rem;cursor:pointer;transition:background .1s ease;}
.fm-emoji__item:hover{background:#f0f6f8;}

/* preview */
.fm-preview{margin-top:14px;}
.fm-preview__label{font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;color:#8b95a1;margin-bottom:6px;}
.fm-preview__banner{background:linear-gradient(90deg,#17a2b8,#0f8ea5);color:#fff;border-radius:.5rem;padding:12px 16px;font-size:.92rem;line-height:1.5;min-height:46px;display:flex;align-items:center;box-shadow:0 4px 14px rgba(23,162,184,.22);}
.fm-preview__banner a{color:#fff;text-decoration:underline;}
.fm-preview__empty{opacity:.75;font-style:italic;}

/* footer */
.fm-footer{display:flex;align-items:center;justify-content:space-between;margin-top:16px;gap:12px;flex-wrap:wrap;}
.fm-counter{font-size:.78rem;color:#8b95a1;}
.fm-counter--warn{color:#e0a800;font-weight:600;}

@media (max-width:575.98px){
  .fm-emoji{width:min(90vw,320px);left:auto;right:0;}
}
`;

export default FlashMessage;
